module.exports = __webpack_public_path__ + "static/media/ojo.e582f51f.svg";